import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "../../stylez/TotalHoursCounter.css";
import { sumEventsHours, countEvents } from "../../functions/calculateHours";

const TotalHoursCounter = ({ events, type = "single" }) => {
  const [totalHours, setTotalHours] = useState(0);
  const [eventCount, setEventCount] = useState(0);

  useEffect(() => {
    if (!events) {
      setTotalHours(0);
      setEventCount(0);
      return;
    }

    if (type === "all") {
      const totalEvents = countEvents(events);
      const hours = Object.values(events).reduce((acc, coachEvents) => {
        return acc + sumEventsHours(coachEvents);
      }, 0);
      setEventCount(totalEvents);
      setTotalHours(hours);
    } else {
      const totalEvents = Array.isArray(events) ? events.length : 0;
      const hours = sumEventsHours(Array.isArray(events) ? events : []);
      setEventCount(totalEvents);
      setTotalHours(hours);
    }
  }, [events, type]);

  // Animation variants
  const counterVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: "easeOut",
      },
    },
  };

  // Number counter animation
  const numberVariants = {
    hidden: { scale: 0.9, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 200,
        damping: 10,
        delay: 0.1,
      },
    },
  };

  return (
    <motion.div
      className="total-hours-counter"
      variants={counterVariants}
      initial="hidden"
      animate="visible"
    >
      <h2>Total Hours</h2>

      <motion.span
        className="hours-value"
        variants={numberVariants}
        initial="hidden"
        animate="visible"
        key={totalHours}
      >
        {totalHours.toFixed(1)}
      </motion.span>
      <span className="event-count">
        ({eventCount} {eventCount === 1 ? "class" : "classes"})
      </span>
    </motion.div>
  );
};

export default TotalHoursCounter;
